<template>
  <section id="limitless-screen" class="personality-custom">
    <div class="screen">
      <div v-textMotion class="personality-custom__text text-screen text-intro">
        <div class="title">{{ $t('personality-custom-screen-title') }}</div>
        <div class="sub-title">{{ $t('personality-custom-screen-sub-title') }}</div>
        <div class="description">
          {{ $t('personality-custom-screen-description') }}
          <sup>1</sup>
        </div>
      </div>
      <div
        id="personality-custom-phone2"
        class="screen__phone wow textInPartMotion"
        data-wow-duration="0.3s"
        data-wow-delay="1s"
        :data-wow-offset="phoneWrapMotionOffset"
        :style="{
          paddingBottom: vm.lang === 'tw' ? '200px' : 0
        }"
      >
        <img v-lazy="require('../../assets/personality/phone-wrap.png')" class="phone-wrap" alt />
        <transition name="fade">
          <div v-show="show === 'screen'" class="screen-wrap">
            <div v-if="canScreen" class="operation-area">
              <canvas
                id="canvas"
                :width="canvasLen"
                :height="canvasLen"
                class="emscripten"
                oncontextmenu="event.preventDefault()"
                @click="showScreenLottie = false"
                @touchstart="showScreenLottie = false"
              ></canvas>

              <div v-if="showScreenLottie" ref="screenLottie" data-bm-renderer="svg" class="lottie"></div>
            </div>
            <div v-else class="operation-area operation-area-bg">
              <img v-lazy="require('../../assets/personality/screen.gif')" class="screen-gif" alt />
            </div>
            <p class="screen-text">19:37</p>
            <p class="screen-text">{{ $t('personality-custom-screen-date') }}</p>
          </div>
        </transition>
        <transition name="fade">
          <div v-show="show === 'ring'" class="ring-wrap">
            <ring ref="ringComponent" :show="show" />
          </div>
        </transition>
      </div>
      <div v-if="vm.lang !== 'tw'" v-textMotion="80" class="personality-custom__text personality-custom__text-ring">
        <div class="title">{{ $t('personality-custom-ring-title') }}</div>
        <div v-if="vm.isMobile && vm.lang == 'zh'" class="sub-title">
          {{ $t('personality-custom-ring-sub-title-mobile1') }}
          <br />
          {{ $t('personality-custom-ring-sub-title-mobile2') }}
        </div>
        <div v-else class="sub-title">{{ $t('personality-custom-ring-sub-title') }}</div>
        <div class="description">{{ $t('personality-custom-ring-description') }}</div>
      </div>
      <div v-if="vm.isMobile && vm.lang !== 'tw'" :class="['ring-video', { videoPlaying: videoPlaying }]">
        <lazy-component
          ref="phoneVideoMobile"
          style="width: 220px;height: 480px;margin: 0 auto;position: relative;"
          @show="showMobileVideo"
        >
          <video
            :src="require(`../../assets${vm.lang === 'zh' ? '/zh' : ''}/personality/ring.mp4`)"
            :poster="require(`../../assets${vm.lang === 'zh' ? '/zh' : ''}/personality/ring.jpg`)"
            preload="meta"
            x5-playsinline
            webkit-playsinline
            playsinline
            x5-video-player-type="h5"
            x5-video-orientation="portraint"
            @click="handlePlaying"
          ></video>
          <img :src="require(`../../assets${vm.lang === 'zh' ? '/zh' : ''}/personality/ring.jpg`)" alt="ColorOS 11" />
        </lazy-component>
        <play-button-text ref="playButtonText" target-video=".ring-video video" class="play-button-text" />
      </div>
    </div>
    <div class="personality-custom-text-bg">{{ $t('personality-custom-bg-text') }}</div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import Ring from './Ring';
import lottie from 'lottie-web/build/player/lottie_svg.min';
import PlayButtonText from '@/components/PlayButtonText';

export default {
  inject: ['vm'],
  components: {
    Ring,
    PlayButtonText
  },
  data() {
    return {
      canScreen: window.WebGLRenderingContext && window.WebAssembly,
      phoneWrapMotionOffset: 0,
      show: 'screen',
      showScreenLottie: true,
      scene: null,
      audioDoms: [[]],
      videoPlaying: false
    };
  },
  computed: {
    canvasLen() {
      let len = this.vm.isMobile ? 432 : 720;
      return len;
    }
  },
  watch: {
    show(newValue, oldValue) {
      // if (this.showScreenLottie) return;
      if (oldValue === 'screen') {
        typeof _ccPause === 'function' && _ccPause(); // eslint-disable-line
        this.canScreen && this.screenLottieAnimation && this.screenLottieAnimation.stop();
        this.$refs.ringComponent.playCurrentVoice();
        this.$refs.ringComponent.playLottie();
      } else {
        this.$refs.ringComponent.pauseCurrentVoice();
        this.canScreen && this.showScreenLottie && this.screenLottieAnimation.play();
        this.$refs.ringComponent.stopLottie();
        typeof _ccResume === 'function' && _ccResume(); // eslint-disable-line
      }
    }
  },
  mounted() {
    if (location.href.indexOf('localhost:800') > -1) return;
    this.getPaintingJs();
    var _ccPause, _ccResume; // eslint-disable-line
    this.phoneWrapMotionOffset =
      screen.availHeight / 2 - document.querySelector('.personality-custom__text').clientHeight;
    //不支持webgl直接返回
    if (!this.canScreen) {
      !this.vm.isMobile && this.initScene();
      return;
    }
    this.ScreenLottiePromise = import(`./js/custom-screen${this.vm.lang === 'zh' ? '-zh' : ''}.json`).then(
      animationData => {
        this.screenLottieAnimation = lottie.loadAnimation({
          container: this.$refs.screenLottie,
          renderer: 'svg',
          loop: true,
          autoplay: false,
          animationData
        });
      }
    );
    if (this.vm.isMobile) {
      this.initMobileScene();
    } else {
      this.initScene();
    }
  },
  methods: {
    handlePlaying() {
      if (!this.$refs.phoneVideoMobile.$el.children[0].paused) {
        this.$refs.phoneVideoMobile.$el.children[0].pause();
        this.videoPlaying = false;
      }
    },
    handleVideoMobilePlay() {
      if (!(this.$refs.phoneVideoMobile.$el && this.$refs.phoneVideoMobile.$el.children)) return;
      this.$refs.phoneVideoMobile.$el.children[0].play();
      this.videoPlaying = true;
    },
    initMobileScene() {
      // 处理文字pin在页面上
      let scene = new ScrollMagic.Scene({
        duration: window.innerHeight + 745,
        offset: 0,
        triggerElement: '.personality-custom',
        triggerHook: 1
      }).addTo(Controller);
      this.handleScreenLottie(scene);
    },
    initScene() {
      let customDom = document.querySelector('.personality-custom');
      let duration = customDom.clientHeight - screen.availHeight;
      // 处理文字pin在页面上
      new ScrollMagic.Scene({
        duration: duration,
        offset: 0,
        triggerElement: '.personality-custom',
        triggerHook: 0
      })
        .setPin('.personality-custom-text-bg')
        .addTo(Controller);

      //处理划过后关闭音乐
      let scene2 = new ScrollMagic.Scene({
        duration: customDom.clientHeight - window.innerHeight / 2,
        offset: 0,
        triggerElement: '.personality-custom',
        triggerHook: 0
      }).addTo(Controller);
      scene2.on('end', event => {
        if (event.scrollDirection === 'FORWARD') {
          this.$refs.ringComponent.pauseCurrentVoice();
          this.$refs.ringComponent.stopLottie();
        } else {
          this.$refs.ringComponent.playCurrentVoice();
          this.$refs.ringComponent.playLottie();
        }
      });
      this.handleScreenLottie(scene2);
      //处理息屏和铃声切换
      let scene = new ScrollMagic.Scene({
        duration: 200,
        triggerElement: '#personality-custom-phone2',
        triggerHook: 0
      }).addTo(Controller);
      scene.on('start', event => {
        if (event.scrollDirection === 'REVERSE') {
          this.show = 'screen';
        }
      });
      scene.on('leave', event => {
        if (event.scrollDirection === 'FORWARD' && this.vm.lang !== 'tw') {
          this.show = 'ring';
        }
      });
    },
    handleScreenLottie(scene) {
      if (!this.canScreen) return;
      //处理进入和离开场景时，播放和暂停lottie
      scene.on('leave', () => {
        this.screenLottieAnimation && this.screenLottieAnimation.pause();
      });
      scene.on('enter', () => {
        this.screenLottieAnimation
          ? this.screenLottieAnimation.play()
          : this.ScreenLottiePromise.then(() => {
              this.screenLottieAnimation.play();
            });
      });
    },
    showMobileVideo() {
      this.$refs.playButtonText.init();
    },
    getPaintingJs() {
      if (typeof WebAssembly === 'undefined') return;
      let files = ['index.js', 'Painting.js', 'Painting.data.js'];
      let body = document.querySelector('body');
      let baseUrl =
        location.href.indexOf('wanyol') > -1 || location.href.indexOf('localhost') > -1
          ? '/feature/static/'
          : this.vm.lang === 'zh'
          ? 'https://static01.coloros.com/www/feature/static/'
          : '/content/dam/oppo/coloros/public/';
      files.forEach(f => {
        let dom = document.createElement('script');
        dom.src = baseUrl + f + '?v=20201125';
        dom.async = false; // 保证执行顺序
        body.appendChild(dom);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.personality-custom {
  position: relative;
  .screen {
    padding-top: 166px;
    position: relative;
    z-index: 5;
    &__phone {
      position: relative;
      width: 434px;
      height: 952px;
      margin: 60px auto 0;
      user-select: none;
      .phone-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 10;
        pointer-events: none;
        user-select: none;
      }
    }
  }
  .screen-wrap {
    width: 414px;
    height: 561px;
    position: absolute;
    left: 50%;
    top: 19px;
    margin-left: -207px;
    z-index: 8;
    .operation-area {
      position: relative;
      width: 360px;
      height: 360px;
      margin: 105px auto 28px;
      canvas {
        width: 100%;
        height: 100%;
      }
      .lottie {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        pointer-events: none;
      }
      .screen-gif {
        width: 100%;
        height: 100%;
      }
    }
    .operation-area-bg {
      background: url('../../assets/personality/personality-screen-operation-area.png');
      background-size: cover;
    }
    .screen-text {
      font-weight: 500;
      font-size: 24px;
      line-height: 105%;
      text-align: center;
      color: #393939;
    }
    .screen-text ~ .screen-text {
      font-size: 18px;
      margin-top: 4px;
    }
    &::after {
      content: ' ';
      position: absolute;
      width: 416px;
      height: 913px;
      left: 50%;
      top: -1px;
      margin-left: -208px;
      background: #000;
      border-radius: 10px;
      z-index: -1;
    }
  }
  .ring-wrap {
    position: absolute;
    bottom: 20px;
    right: 10px;
    z-index: 5;
    &::after {
      content: ' ';
      position: absolute;
      width: 416px;
      height: 911px;
      left: 50%;
      bottom: 3px;
      margin-left: -208px;
      background: #999;
      border-radius: 10px;
      z-index: -1;
    }
  }
  .personality-custom__text-ring {
    margin-top: 60px;
    padding-bottom: 200px;
  }
  &__text {
    text-align: center;
    .description {
      width: 620px;
      margin: 0 auto;
    }
  }
  &-text-bg {
    position: absolute;
    width: 5em;
    top: 0;
    left: 50%;
    // font-size: 566px;
    font-size: 30.2vw;
    line-height: 804px;
    color: #f9fafa;
    z-index: 0;
    letter-spacing: -0.06em;
    font-variation-settings: 'wght' 1000;
    transform: translateX(-50%);
  }
}

@media only screen and (max-width: 734px) {
  .personality-custom {
    .screen {
      padding-top: 0;
      background: #131313;
      .personality-custom__text {
        margin-top: 0;
      }

      &__phone {
        width: 290px;
        // height: 636px;
        height: 465px;
        margin-top: 0;
        overflow: hidden;
        .phone-wrap {
          height: 636px;
        }
        .screen-wrap {
          width: 276px;
          margin-left: -138px;
          height: 452px;
          top: 12px;
          user-select: none;
          .operation-area {
            width: 216px;
            height: 216px;
            margin: 64px auto 14px;
            user-select: none;
            .lottie {
              width: 120%;
              height: 120%;
              top: -10%;
              left: -10%;
            }
          }
          .screen-text {
            font-size: 16px;
            user-select: none;
          }
          .screen-text ~ .screen-text {
            font-size: 12px;
            margin-top: 2.5px;
          }
          &::after {
            width: 276px;
            height: 610px;
            margin-left: -138px;
          }
        }
        .ring-wrap {
          width: 276px;
          height: 390px;
          right: 7px;
          bottom: 12px;
          &::after {
            width: 276px;
            height: 610px;
            margin-left: -138px;
          }
        }
      }
    }
    .personality-custom__text-ring {
      background: #fff;
      padding-left: 20px;
      padding-top: 40px;
      padding-bottom: 70px;
      position: relative;
      z-index: 1;
    }
    .text-screen {
      .title,
      .sub-title {
        color: #fff;
      }
      .description {
        color: rgba($color: #fff, $alpha: 0.5);
      }
    }
    .ring-video {
      position: relative;

      background: #fff;
      height: 540px;
      img,
      video {
        width: 100%;
        height: 100%;
      }
      video {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
      }
      svg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .play-button-text {
        bottom: 22px;
      }
    }
    .videoPlaying {
      svg {
        display: none;
      }
    }
    &__text {
      text-align: left;
      padding-top: 60px;
      .description {
        margin: 0;
      }
    }
  }
}
// 英文样式
html:not([lang|='zh-CN']) {
  .personality-custom {
    .screen {
      padding-top: 0;
    }
    .personality-custom__text .description {
      width: 587px;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s linear;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
